import { render, staticRenderFns } from "./InviteCollaboratorModal.vue?vue&type=template&id=7400388e&scoped=true&"
import script from "./InviteCollaboratorModal.vue?vue&type=script&lang=js&"
export * from "./InviteCollaboratorModal.vue?vue&type=script&lang=js&"
import style0 from "./InviteCollaboratorModal.vue?vue&type=style&index=0&id=7400388e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7400388e",
  null
  
)

export default component.exports